import React, { useCallback, useEffect, useState } from 'react';

export type FormulaTarget = 'lower' | 'upper';

interface OpenModalOptions {
  // Scroll to and pulse-highlight one of the consequence formula inputs once
  // the modal has loaded.
  focusFormula?: FormulaTarget;
}

interface ScenarioContextInterface {
  id: string | undefined;
  isOpen: boolean;
  focusFormula: FormulaTarget | undefined;
  openModal: (id?: string | number, options?: OpenModalOptions) => void;
  closeModal: () => void;
}

const ScenarioContext = React.createContext<Partial<ScenarioContextInterface>>({});

const ScenarioProvider = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState<string | number | undefined>(undefined);
  const [focusFormula, setFocusFormula] = useState<FormulaTarget | undefined>(undefined);
  const openModal = useCallback(
    (id?: string | number, options?: OpenModalOptions) => {
      if (id) {
        setId(id);
      }
      setFocusFormula(options?.focusFormula);
      setIsOpen(true);
    },
    [setIsOpen],
  );
  useEffect(() => {
    if (!isOpen) {
      setId(undefined);
      setFocusFormula(undefined);
    }
  }, [isOpen]);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <ScenarioContext.Provider
      value={{
        isOpen,
        focusFormula,
        openModal,
        closeModal,
        id,
      }}
      {...props}
    />
  );
};

const useScenario = () => {
  const context = React.useContext(ScenarioContext);
  if (context === undefined) {
    throw new Error('useScenario must be used within a ScenarioProvider');
  }
  return context as ScenarioContextInterface;
};

export { ScenarioProvider, useScenario };
